import { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { getLocalStorageItem } from "../../Utils";
import { AviatorSocketURL } from "../../ApiServices/Axios";

const SOCKET_BASE = "wss://api.tajwin.com";

const SocketHoc = (Comp) => {
  const NewComp = () => {
    const [socket, setSocket] = useState(null);
    const [isFlying, setIsFlying] = useState(null);
    const [waitingTime, setWaitingTime] = useState(null);
    const [AllBets, setAllBets] = useState(null);

    useEffect(() => {
      let socketInstance;
      const token = getLocalStorageItem("accessToken");
      if (token) {
        socketInstance = io(AviatorSocketURL, {
          transports: ["websocket"],
          path: "/socket.io",
          auth: { token },
        });

        socketInstance.on("connect", () => {
          console.log("✅ Socket connected:", socketInstance.id);
        });

        socketInstance.on("connect_error", (err) => {
          console.error("❌ Connection error:", err.message);
        });

        setSocket(socketInstance);
      }

      return () => {
        socketInstance?.disconnect();
      };
    }, []);

    useEffect(() => {
      console.log(socket, "socket");
      if (socket) {
        socket.on("gamePlay", (data) => {
          setIsFlying({ ...data });
        });

        socket.on("betDataCollection", (data) => {
          setAllBets(data);
        });

        socket.on("initialGame", (data) => {
          setWaitingTime(data);
          console.log(data, "waitingTime");
        });
      }
    }, [socket]);

    return (
      <Comp
        AllBets={AllBets}
        setWaitingTime={setWaitingTime}
        setIsFlying={setIsFlying}
        waitingTime={waitingTime}
        isFlying={isFlying}
      />
    );
  };

  return NewComp;
};

export default SocketHoc;
